let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1yeVn")).then(() => parcelRequire('1TvGI'));